<!--登录页面-->
<template>
  <div class="login">
    <!-- <div class="header">
            <div class="container_wrap">
                <div class="logoAndname">
                    <img src="~@/assets/images/login/pic-logo.png" style="width:100%;height:100%">
                </div>
                <div class="headnav">
                    <a href="#" v-for="(item,index) in navArr" :key="index">{{item.name}}</a>
                </div>  
                <div class="headlefticon">
                    <div class="headicon">
                        <div class="loginbtn">登录</div>
                    </div>
                    <div class="headicon">
                        <div class="loginbtn registerbtn">注册</div>
                    </div>
                </div>
            </div>
        </div> -->
    <div class="logincontainer">
      <div class="logincontainerEntureWidth">
        <div class="bgitem"></div>
        <div class="logincontainerItem">
          <el-menu
            :default-active="activeIndex"
            class="elmenu"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item index="登录">登录</el-menu-item>
            <el-menu-item index="注册">注册</el-menu-item>
          </el-menu>
          <div class="leftLogin" v-if="activeIndex == '登录'">
            <template v-if="!gobackPasswordFlag">
              <el-form
                label-width="108px"
                :model="loginFormdata"
                ref="ruleForm"
                :rules="rules"
              >
                <el-form-item label="用户名" prop="nameOrPhone">
                  <el-input
                    placeholder="用户名/手机号"
                    v-model="loginFormdata.nameOrPhone"
                    clearable
                    style="width: 240px; height: 40px"
                  ></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                  <el-input
                    placeholder="请输入密码"
                    v-model="loginFormdata.password"
                    style="width: 240px; height: 40px"
                    show-password
                  ></el-input>
                </el-form-item>
                <div
                  class="loginFont tipsCommon"
                  @click="submitForm('ruleForm')"
                >
                  登录
                </div>
                <div class="forget tipsCommon">
                  <div class="forgetpassword" @click="forgetpasswordClickFun()">
                    忘记密码
                  </div>
                </div>
              </el-form>
            </template>

            <template v-else>
              <el-form
                label-width="108px"
                :model="gobackPasswordData"
                ref="ruleForm3"
                :rules="rules3"
              >
                <el-form-item label="手机号" prop="upd_phone">
                  <el-input
                    placeholder="请输入中国大陆手机号"
                    v-model="gobackPasswordData.upd_phone"
                    clearable
                    style="width: 240px; height: 40px"
                    :disabled="ensureCodeFlag"
                  ></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="upd_code">
                  <el-input
                    placeholder="请输入验证码"
                    v-model="gobackPasswordData.upd_code"
                    clearable
                    style="width: 111px; height: 34px"
                    class="inputidecode"
                    :disabled="ensureCodeFlag"
                  ></el-input>
                  <el-button
                    @click="getidecodeFun(gobackPasswordData.upd_phone)"
                    :disabled="ensureCodeFlag"
                    >{{ getidecodeData }}</el-button
                  >
                </el-form-item>
                <!-- 验证成功之后的表单 -->
                <template v-if="ensureCodeFlag">
                  <el-form-item label="密码" prop="upd_password">
                    <el-input
                      placeholder="请输入密码"
                      v-model="gobackPasswordData.upd_password"
                      style="width: 240px; height: 40px"
                      show-password
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="重复密码" prop="upd_password2">
                    <el-input
                      placeholder="请再次确认密码"
                      v-model="gobackPasswordData.upd_password2"
                      style="width: 240px; height: 40px"
                      show-password
                    ></el-input>
                  </el-form-item>
                </template>
                <div
                  class="loginFont tipsCommon"
                  @click="submitForm3('ruleForm3')"
                >
                  确定
                </div>
                <div class="forget tipsCommon">
                  <div class="forgetpassword" @click="gobackForLoginFun()">
                    返回登录
                  </div>
                </div>
              </el-form>
            </template>
          </div>
          <div class="rightRegister" v-if="activeIndex == '注册'">
            <el-form
              label-width="108px"
              :model="registFormdata"
              ref="ruleForm2"
              :rules="rules2"
            >
              <!-- <el-form-item label="类型" prop="type">
                <el-radio-group v-model="registFormdata.is_danwei">
                  <el-radio :label="2">个人</el-radio>
                  <el-radio :label="1">单位</el-radio>
                </el-radio-group>
              </el-form-item> -->
              <el-form-item
                v-if="registFormdata.is_danwei != 1"
                label="用户名"
                prop="reg_name"
              >
                <el-input
                  placeholder="用户名"
                  v-model="registFormdata.reg_name"
                  clearable
                  style="width: 240px; height: 40px"
                ></el-input>
              </el-form-item>
              <el-form-item v-else label="单位名" prop="reg_name2">
                <el-input
                  placeholder="单位名称"
                  v-model="registFormdata.reg_name2"
                  clearable
                  style="width: 240px; height: 40px"
                ></el-input>
              </el-form-item>
              <el-form-item label="密码" prop="reg_password">
                <el-input
                  placeholder="请输入密码"
                  v-model="registFormdata.reg_password"
                  style="width: 240px; height: 40px"
                  show-password
                ></el-input>
              </el-form-item>
              <el-form-item label="重复密码" prop="reg_password2">
                <el-input
                  placeholder="请再次确认密码"
                  v-model="registFormdata.reg_password2"
                  style="width: 240px; height: 40px"
                  show-password
                ></el-input>
              </el-form-item>
              <el-form-item label="手机号" prop="reg_phone">
                <el-input
                  placeholder="请输入中国大陆手机号"
                  v-model="registFormdata.reg_phone"
                  clearable
                  style="width: 240px; height: 40px"
                ></el-input>
              </el-form-item>
              <el-form-item label="验证码" prop="reg_code">
                <el-input
                  placeholder="请输入验证码"
                  v-model="registFormdata.reg_code"
                  clearable
                  style="width: 111px; height: 34px"
                  class="inputidecode"
                ></el-input>
                <el-button @click="getidecodeFun(registFormdata.reg_phone)">{{
                  getidecodeData
                }}</el-button>
              </el-form-item>
              <div 
                class="loginFont tipsCommon"
                @click="submitForm2('ruleForm2')"
              >
              {{loading ? '注册中...' : '注册'}}
                
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      loading: false,
      navArr: [
        { name: "首页" },
        // { name: "组织结构" },
        { name: "新闻资讯" },
        { name: "通知公告" },
        { name: "免费课程" },
        { name: "星星展示" },
        { name: "资质查询" },
      ],
      activeIndex: "登录",
      inputusername: "", //用户名
      inputpassword: "", //密码
      inputmobilphone: "", //手机号码
      inputIdecode: "", //验证码
      inputpasswordagain: "", //再次输入密码
      getidecodeData: "获取验证码",
      inputdepartment: "",
      loginFormdata: {
        nameOrPhone: "",
        password: "",
      },
      registFormdata: {
        is_danwei: 2,
        reg_phone: "",
        reg_code: "",
        reg_name: "",
        reg_password2: "",
        reg_password: "",
      },

      gobackPasswordData: {
        upd_phone: "",
        upd_code: "",
        upd_password: "",
        upd_password2: "",
      },
      gobackPasswordFlag: false,
      ensureCodeFlag: false, //忘记密码  验证码正确的标志

      rules: {
        nameOrPhone: [
          { required: true, message: "请输入用户名/手机", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      rules2: {
        reg_phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { min: 11, max: 11, message: "长度在11个字符", trigger: "blur" },
        ],
        reg_code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { min: 4, max: 4, message: "长度在4个字符", trigger: "blur" },
        ],
        reg_name: [
          { required: true, message: "请输入用户名" , trigger: "blur"},
          { min: 3, max: 16, message: "长度在3-6个字符" , trigger: "blur"},
        ],
        reg_name2:[
          { required: true, message: "请输入单位名" , trigger: "blur"},
          { min: 3, max: 16, message: "长度在3-6个字符" , trigger: "blur"},
        ],
        reg_password: [{ required: true, message: "请输入密码", trigger: "blur"}],
        reg_password2: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
        ],
      },
      rules3: {
        upd_phone: [
          { required: true, message: "手机不能为空" },
          { min: 11, max: 11, message: "手机号码必须为11位" },
        ],
        upd_code: [
          { required: true, message: "请输入验证码" },
          { min: 4, max: 4, message: "手机号码必须为4位" },
        ],
        upd_password: [
          { required: true, message: "请输入重置密码", trigger: "blur" },
        ],
        upd_password2: [
          { required: true, message: "请再次输入重置密码", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    getidecodeData(newval, oldval) {
      if (newval == 0) {
        this.getidecodeData = "获取验证码";
      }
    },
  },
  methods: {
    //忘记密码  点击事件
    forgetpasswordClickFun() {
      this.gobackPasswordFlag = true;
      this.getidecodeData = "获取验证码";
      this.resetForm();
    },
    //返回登录点击事件
    gobackForLoginFun() {
      this.gobackPasswordFlag = false;
      this.getidecodeData = "获取验证码";
      this.resetForm();
    },
    handleSelect(val) {
      this.activeIndex = val;
      this.inputusername = "";
      this.inputpassword = "";
      this.inputmobilphone = "";
      this.inputIdecode = "";
      this.inputpasswordagain = "";
      this.inputdepartment = "";
      this.resetForm();
    },
    //登录点击事件
    loginFun() {
      if (
        this.inputusername.trim() == "" ||
        this.inputpassword.trim() == "" ||
        this.inputdepartment.trim() == ""
      ) {
        this.$message({ type: "error", message: "单位/用户名/密码不能为空" });
        this.inputusername = "";
        this.inputpassword = "";
        return;
      }
      //发起请求判断密码账号 是否正确
    },
    //注册点击事件
    registerFun() {
      if (this.inputpasswordagain != this.inputpassword) {
        this.$message({ type: "error", message: "密码确认错误" });
        // this.inputusername="";
        this.inputpassword = "";
        // this.inputdepartment="";
        this.inputpasswordagain = "";
        return;
      }
      if (
        this.inputusername.trim() == "" ||
        this.inputpassword.trim() == "" ||
        this.inputdepartment.trim() == "" ||
        this.inputpasswordagain.trim() == ""
      ) {
        this.$message({ type: "error", message: "内容不能为空" });
        return;
      }
      //发起请求判断
    },

    submitForm(formName) {
      const that = this;
      console.log("formName");
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.$api.post(
            "/api/index/login",
            that.loginFormdata,
            (r) => {
              that.$message.success("登录成功");
              localStorage.setItem("_token", r.data.token);
              if(this.$route.query.url){
                window.open(decodeURIComponent(this.$route.query.url),'_self')
              }else{
                that.$router.push({ name: "indexlayout" });
                location. reload()
              }
              
            },
            (r) => {
              that.$message.error(r.msg);
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    submitForm2(formName) {
      const that = this;
      console.log("formName");
      that.$refs[formName].validate((valid) => {
        if (valid) {
          if (that.registFormdata.reg_password != that.registFormdata.reg_password2) {
            that.$message.error("两次密码不一致");
            return false;
          }
          if(that.loading){
            return 
          }
          that.loading = true;
          that.$api.post(
            "/api/index/register",
            that.registFormdata,
            (r) => {
              that.loading = false;
              that.$message.success("注册成功");
              localStorage.setItem("_token", r.data.token);
              window.location.href = '/';
              return 
              // that.$router.push({ name: "videoSaiList" });
            },
            (r) => {
              that.$message.error(r.msg);
              that.loading = false;
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    submitForm3(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.ensureCodeFlag) {
            //验证码及手机 未验证
            this.checkPhoneCode(
              this.gobackPasswordData.upd_phone,
              this.gobackPasswordData.upd_code
            );
          } else {
            //已经成功验证
            if (
              this.gobackPasswordData.upd_password !=
              this.gobackPasswordData.upd_password2
            ) {
              this.$message.error("两次密码不一致");
              return false;
            }

            this.$api.post(
              "/api/index/setPasswordByPhone",
              {
                phone: this.gobackPasswordData.upd_phone,
                password: this.gobackPasswordData.upd_password,
              },
              (res) => {
                this.gobackPasswordFlag = false;
                this.gobackPasswordData = {
                  upd_phone: "",
                  upd_code: "",
                  upd_password: "",
                  upd_password2: ""
                }
                this.$message.success("请登录！")
              },
              (err) => {
                console.log(err);
              }
            );
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //获取验证码 点击事件
    getidecodeFun(phone) {
      const that = this;
      that.$api.post(
        "/api/index/phonecode",
        {
          phone: phone,
        },
        (r) => {
          this.$message.success("发送成功");
          if (this.getidecodeData == "获取验证码") {
            this.getidecodeData = 59;
            var that = this;
            var timetime;
            timetime = setInterval(function () {
              that.getidecodeData -= 1;
              if (that.getidecodeData <= 0) {
                clearInterval(timetime);
              }
            }, 1000);
          }
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
    //检查验证码是否输入正确
    checkPhoneCode(phone, code) {
      this.$api.post(
        "/api/index/checkPhoneCode",
        { phone: phone, code: code },
        (res) => {
          this.ensureCodeFlag = true;
          this.$message.success("验证通过，请重置密码！")
        },
        (err) => {
          this.$message.error(err.msg);
        }
      );
    },
    resetForm() {
      var formName = ["ruleForm", "ruleForm2", "ruleForm3"];
      formName.some((item) => {
        if (this.$refs[item]) {
          this.$refs[item].resetFields();
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import "./Login.scss";
.elmenu {
  display: flex;
  justify-content: center;
}
// /deep/.el-menu{
//      display:flex;
//      justify-content: center;
// }
/deep/.el-menu-item {
  font-size: 16px;
  display: inline-block;
}
.is-active {
  font-size: 16px;
  color: #000;
  font-weight: bold;
}
.inputidecode {
  .el-input__inner {
    padding-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// Login.vue?33b9f076